module.exports = __webpack_public_path__ + "img/text-hol.d9d8fcaa.png";